import { toast } from "react-toastify";
import api from "./api/api";

const ServiceRepresentado = {
  listRepresentado: async (page: any, perPage: any, search?: any) => {
    try {
      if (search) {
        const res = await api.get(
          `/representados?page=${page}&perPage=${perPage}&s=${search}`
        );
        return res;
      } else {
        const res = await api.get(
          `/representados?page=${page}&perPage=${perPage}`
        );
        return res;
      }
    } catch (error: any) {
      return error.response;
    }
  },
  adicionarRepresentado: async (payload: any) => {
    try {
      const res = await api.post("/representados", payload);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  /* findByName: async (page: any, perPage: any, findByName: any) => {
    try {
      const res = await api.get(
        `/clientes?page=${page}&perPage=${perPage}&s=${findByName}`
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  }, */
  editarRepresentado: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/representados/${id}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      toast.error("Erro ao Editar Representado");
      return error.response;
    }
  },
  deleteRepresentado: async (id: any) => {
    try {
      const res = await api.delete(`/representados/${id}`);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      toast.error("Erro ao Deletar Representado");
      return error.response;
    }
  },
};

export default ServiceRepresentado;
